import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reverse } from 'named-urls';
import AdminDashboard from '$components/staff/AdminDashboard';
import AuthorDashboard from '$components/staff/AuthorDashboard';
import routes from '@achievable-me/tundra-wizard/routes';
import {
  isAdmin,
  isAuthor,
  isEditor,
  isManager,
  isSales,
} from '@achievable-me/tundra-wizard/auth';
import styles from './styles.scss';

class StaffDashboard extends Component {
  render() {
    const { currentUser } = this.props;
    const { organizationUuid } = currentUser;

    if (isAdmin(currentUser)) {
      return <AdminDashboard currentUser={currentUser} />;
    }

    if (isAuthor(currentUser) || isEditor(currentUser)) {
      return <AuthorDashboard currentUser={currentUser} />;
    }

    if (organizationUuid && isManager(currentUser)) {
      return (
        <Redirect
          to={reverse(routes.staff.organization.overview, { organizationUuid })}
        />
      );
    }

    if (isSales(currentUser)) {
      return <Redirect to={routes.staff.organizations} />;
    }

    return (
      <div className={styles.layout}>
        Hi, this is the generic staff dashboard.
        <br />
        <br />
        If you are seeing this, it probably means your grants are not set up correctly.
      </div>
    );
  }
}

export default StaffDashboard;
